/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";[_nghost-%COMP%]{display:block}.main[_ngcontent-%COMP%]{height:100%;display:flex;flex-flow:column;justify-content:flex-start;max-width:1390px;margin:0 auto}.page-loading[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;bottom:0;left:0;right:0;top:0;background:#fff}.page-loading--center-middle[_ngcontent-%COMP%]{position:absolute;width:100%;top:30vh;text-align:center}.page-loading-message[_ngcontent-%COMP%]{color:#0669b2;font-weight:700;font-size:28px;margin-bottom:40px}"];
export { styles as styles };
